export const environment = {
  salesforceUrl: "https://login.salesforce.com",
  production: true,
  baseUrl: "https://devapi.lghvac.com/api/",
  umbracoUrl: "https://dev.lghvac.com/",
  salesforceClientId: "3MVG9y6x0357HlefU5p7hxTSDB0HnlEQUUxwMELTsofoIANyKLhmw7sUHNyl2F80ZN8L1WOqREbn2psYAq7BA",
  oauthcallbackUrl: "https://dev.lghvac.com/",
  googleMapsApiKey: "'AIzaSyAV2Sxf3_SzFIIwaSlI17j4dM_wjs4ZZ3c", // Eric's personal key.  Please don't use in prod.  It costs money.
  archivePath: "https://archive.lghvac.com",
  apiUri: "https://dev.lghvac.com/umbraco/api/",
  employeeDetailLink: "/employee-detail"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts